import SolicitudCredito from "../interfaces/SolicitudCredito.interface";

const getEstructura = (): SolicitudCredito => {
    const solicitudCredito: SolicitudCredito = {
        IdSolicitudCredito: 0,
        IdCliente: 0,
        tipo: {
            IdTipo: 0,
            value: ""
        },
        monto: {
            IdMonto: 0,
            value: ""
        },
        montoAprobado: "0",
        plazo: {
            IdPlazo: 0,
            value: ""
        },
        formaPago: {
            IdFormaPago: 0,
            value: "",
        },
        status: {
            IdStatus: 0,
            value: "",
        },
        fechaCreacion: "",
        horaCreacion: "",
        fechaModificacion: "",
        horaModificacion: "",
        usuario: {
            IdUsuario: 0,
            nombre: ""
        },
        observaciones: ""
    };
    return solicitudCredito;
};

const SolicitudCreditoModel = {
    getEstructura,
};

export default SolicitudCreditoModel;